export class SessionConnectedAction {
  static readonly type = '[Session] connected to server stream';
}
